import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./styles/index.css";

// Handle chunk load failures (happens when deployment occurs while user has site open)
window.addEventListener('error', (event) => {
  const isChunkLoadError =
    event.message.includes('Failed to fetch dynamically imported module') ||
    event.message.includes('Importing a module script failed') ||
    event.message.includes('Cross-origin script load denied');

  if (isChunkLoadError) {
    console.warn('Chunk load failed (likely due to deployment), reloading page...');
    window.location.reload();
  }
});

createRoot(document.getElementById("root")!).render(<App />);
